import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  useTheme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { ModalProps } from './Modal.types'

export const Modal = (props: ModalProps) => {
  const {
    open,
    handleClose,
    header,
    footer,
    body,
    className,
    footerAlignment = 'end',
    headerCloseButton = true,
    isHeaderCloseButtonDisabled = false,
    ...otherProps
  } = props

  const theme = useTheme()

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      // slotProps={{
      //   paper: {
      //     sx: {
      //       width: '60%',
      //       maxWidth: '60vw',
      //     },
      //   },
      // }}
    >
      {header && (
        <DialogTitle
          sx={{
            height: '64px',
            padding: '18px 36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            borderRadius: '4px 4px 0px 0px',
          }}
        >
          <Typography variant="h6" component="span">
            {header}
          </Typography>
          {headerCloseButton && (
            <IconButton
              onClick={handleClose}
              disabled={isHeaderCloseButtonDisabled}
              sx={{
                filter: 'invert(1)',
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent
        sx={{
          padding: '36px 36px',
        }}
      >
        {body}
      </DialogContent>

      {footer && (
        <DialogActions
          sx={{
            padding: '36px 36px',
            justifyContent:
              footerAlignment === 'end' || footerAlignment === undefined
                ? 'flex-end'
                : footerAlignment === 'start'
                  ? 'flex-start'
                  : 'center',
          }}
        >
          {footer}
        </DialogActions>
      )}
    </Dialog>
  )
}
